module.exports = __webpack_public_path__ + "static/media/img.appError.9446224a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/display/modules/Home/Workbench3/UI.AppError/img.appError.svg
// module id = 6805
// module chunks = 0